import type { GoodCustomsInformation, PackingListRow } from "@RequestFormV2/sections/PackingList/types";
import { isContainerRow } from "@RequestFormV2/sections/PackingList/utils/packingListSplit";
import { isPackingListRowEmpty } from "@RequestFormV2/sections/PackingList/utils/isRowEmpty";

function hasValue(value: unknown) {
  return value !== null && value !== undefined && value !== "";
}

/** A commodity satisfies the Parcel requirement when description, HS Code and Value are all filled. */
export function isCommodityComplete(commodity: GoodCustomsInformation | undefined): boolean {
  if (!commodity) return false;
  return hasValue(commodity.description) && hasValue(commodity.hs_code) && hasValue(commodity.value);
}

/** At least one commodity (across all rows) has description, HS Code and Value filled. */
export function hasCompleteParcelCommodity(rows: PackingListRow[] | undefined): boolean {
  return (rows ?? []).some((row) => (row.good_customs_information ?? []).some(isCommodityComplete));
}

/** At least one non-empty handling-unit (non-container) row exists. */
export function hasParcelHandlingUnit(rows: PackingListRow[] | undefined): boolean {
  return (rows ?? []).some((row) => !isContainerRow(row) && !isPackingListRowEmpty(row));
}
